/** L'anonimizzazione, dal lato della pagina.
 *
 * Volti e targhe si cercano prima che qualcosa esca; questa schermata guarda a
 * che punto sta e fa partire il passaggio. Il lavoro dura minuti e sta in coda:
 * qui si accoda e si rilegge, non si aspetta.
 */
import { get, send } from './api'

export interface PrivacyState {
  photos: number
  scanned: number
  with_zones: number
  faces: number
  plates: number
  /** Ogni fotogramma e' stato guardato: e' questo che la consegna afferma. */
  complete: boolean
}

export function state(inspectionId: string): Promise<PrivacyState> {
  return get<PrivacyState>(`/inspections/${encodeURIComponent(inspectionId)}/privacy`)
}

export function startScan(inspectionId: string, key: string): Promise<{ queued: boolean }> {
  return send<{ queued: boolean }>(
    `/inspections/${encodeURIComponent(inspectionId)}/privacy-scan`,
    {},
    key,
  )
}
